let transfer = [
	{
		path: '/transferList',
		name: 'transferList',
		component: ()=> import('@/views/transfer/transferList'),
		meta: {
			name: '标源_转让标记管理列表',
			breadCrumbName: '转让标记管理'
		}
	},
	{
		path: '/transferAdd',
		name: 'transferAdd',
		component: ()=> import('@/views/transfer/transferAdd'),
		meta: {
			name: '标源_专利交易查询',
			breadCrumbName: '添加待标记专利'
		}
	},
	{
		path: '/transferBrand',
		name: 'transferBrand',
		component: ()=> import('@/views/transfer/transferBrand'),
		meta: {
			name: '标源_专利交易查询',
			breadCrumbName: '已转让专利查询'
		}
	}
]
export default transfer;